import type { ReactElement } from 'react';
import React from 'react';
import { useToastState } from './utils/useToastState';
import { Alert } from '@interstate/components/Alert';

export type ToastType = 'error' | 'success';
export type ToastProps = {
    isLoading: boolean;
    isLoaded: boolean;
    isError: boolean;
    setIsToastVisible?: (visible: boolean) => void;
    getTitle?: (type: ToastType) => string | undefined;
    getMessage?: (type: ToastType) => ReactElement | string | undefined;
    timer?: number;
};

export const Toast = ({ isLoading, isLoaded, isError, getMessage, getTitle, setIsToastVisible, timer }: ToastProps) => {
    const { successToastShown, errorToastShown } = useToastState({
        isLoading,
        isLoaded,
        isError,
        timer
    });

    const successTitle = getTitle?.('success');
    const successMessage = getMessage?.('success');

    const errorTitle = getTitle?.('error');
    const errorMessage = getMessage?.('error');

    const shouldShowSuccessToast = Boolean(successToastShown && (successTitle || successMessage));
    const shouldShowErrorToast = Boolean(errorToastShown && (errorTitle || errorMessage));

    React.useEffect(() => {
        if (!setIsToastVisible) {
            return;
        }
        setIsToastVisible(shouldShowSuccessToast || shouldShowErrorToast);
    }, [shouldShowSuccessToast, shouldShowErrorToast]);

    return (
        <>
            {shouldShowSuccessToast && (
                <Alert disableSuccessFade type="success" title={successTitle}>
                    {successMessage}
                </Alert>
            )}
            {shouldShowErrorToast && (
                <Alert type="error" title={errorTitle}>
                    {errorMessage}
                </Alert>
            )}
        </>
    );
};
